import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #0d9488',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function SwingNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#2dd4bf' }}>〽️ Swing Point</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={data.which || 'high'} onChange={(e) => onChange('which', e.target.value)} style={selStyle}>
        <option value="high">Last Swing High</option>
        <option value="low">Last Swing Low</option>
      </select>

      <label style={{ fontSize: 11, color: 'var(--muted)' }}>Lookback (bars)</label>
      <input
        type="number" min={3} value={data.lookback ?? 60}
        onChange={(e) => onChange('lookback', parseInt(e.target.value, 10) || 60)}
        style={selStyle}
      />

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        Outputs the price of the most recent fractal swing. Compare it against price
        (e.g. close crosses above the last swing high).
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#0d9488' }} />
    </div>
  );
}
